export default "__VITE_ASSET__Btgt2W4k__"